import React, {Component} from 'react'
import { connect } from 'react-redux'
import { Field, FieldArray } from 'redux-form'
import { Trans } from "react-i18next";
import InputField from './InputField'
import Select from './Select'
import { Row, Col } from 'reactstrap';


const Input = (props) =>{
  const {change, name} = props
  if(props.type=='text' || props.type=='number' || props.type=='password')	  
	  return <InputField {...props}   />
  else if(props.type=='select')
	  return <Select {...props} />
  else if(props.type=='range'){
	  return <Row>
	    <Col>		
		    <InputField {...{type: 'number', name: props.name+".min", placeholder: 'Min'}} /> 
	    </Col>
	    <Col>		
		    <InputField {...{type: 'number', name: props.name+".max", placeholder: 'Max'}} />
	    </Col>
	  </Row>
  }
  else if(props.type=='checkbox'){
	  return <div>
	    <InputField {...{type: 'checkbox', className: 'checkbox-input', name: `${props.name}`}} /> 
	  </div>
  }
  else if(props.type=='checkbox_list'){
	  return <div>
	    {props.options != null ? props.options.map(o => <div key={o.name}><InputField {...{type: 'checkbox', className: 'checkbox-input', name: `${props.name}[${o.name}]`}} /> {o.title}</div>) : ""}
	  </div>
  }
  else if(props.type=='grouped_checkbox_list'){

	  return <div>
	    {props.groups != null ? props.groups.map(g =>{
		    const isChecked = (props.values != null &&  props.values.country_iso_code != null ? g.options.filter(o => props.values[name][o.value]===true).length ==  g.options.length : false)
		    return <div key={g.name}>	    
		      {g.options.length > 1 && <React.Fragment><input type="checkbox" checked={isChecked}  onChange={(props, newValue) => {g.options.map(o => change(`${name}[${o.value}]`, !isChecked))} } />  <b>{g.title}</b> </React.Fragment>}
		      {g.options != null ? g.options.map(o => <div key={o.value}><InputField {...{type: 'checkbox', className: `checkbox-input ${g.options.length > 1 ? 'margin-5px' : 'bold'} `, name: `${props.name}[${o.value}]` }}  /> {o.name}</div>) : ""}
	      </div>
	    }) : ""}
	  </div>
  }
  else
	  return ""

}



const mapStateToProps = (state, ownProps) => {
  return {
	  values: (state.form != null && state.form[ownProps.form_name] != null && ownProps.form_name != null ? state.form[ownProps.form_name].values : {} )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {

  return {

  }
}

const Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(Input)

export default Container
